import {
  ItemTypeEnum,
  ProductTypeEnum,
  crownItemSchema,
  getBaseProductSchema,
  productMaterialCharacteristicsSchema,
  productPreferencesSchema,
  type CrownProduct,
} from "@jasper/client-models";
import {
  isTeethStepComplete,
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { MaterialStep, PreferencesStep, CrownTeethStep } from "./constants";

export type CrownStepKey =
  | typeof StepKeysEnum.crownTeeth
  | typeof StepKeysEnum.material
  | typeof StepKeysEnum.preferences;

export const CrownWorkflowConfiguration: ProductWorkflowConfiguration<
  CrownProduct,
  CrownStepKey
> = {
  productType: ProductTypeEnum.crown,
  itemType: ItemTypeEnum.crown,
  steps: [
    new CrownTeethStep({ type: "FIXED" }),
    new MaterialStep(),
    new PreferencesStep(),
  ],
  teethSelection: TeethSelectionEnum.MIXED,
  isBulkSupported: true,
  bulkCompatibleTypes: [ProductTypeEnum.splintedCrown],

  isValidProduct(product) {
    return getBaseProductSchema({ itemSchema: crownItemSchema }).safeParse(
      product
    ).success;
  },

  getCompletedSteps(product) {
    const completed: CrownStepKey[] = [];

    if (
      isTeethStepComplete({
        teeth: product.teeth,
        teethSelection: this.teethSelection,
      })
    ) {
      completed.push(StepKeysEnum.crownTeeth);
    }

    const isMaterialStepComplete =
      productMaterialCharacteristicsSchema.safeParse(product).success;

    if (product.items?.length && isMaterialStepComplete) {
      completed.push(StepKeysEnum.material);
    }

    const isPreferencesStepComplete =
      productPreferencesSchema.safeParse(product).success;

    if (isPreferencesStepComplete) {
      completed.push(StepKeysEnum.preferences);
    }

    return completed;
  },
};
